'use client'

import { useMemo, useState } from 'react'

import { InputSearchbox } from '@/components/common/Input'
import { NoResults } from '@/components/common/NoResults'
import { usePage } from '@/components/providers/PageProvider'
import { useCardMap } from '@/hooks/useCardMap'
import { useLinkInternal } from '@/hooks/useLinkInternal'
import { buildCardId } from '@/utils/cardUtil'
import { isNonEmptyString, searchIncludes } from '@/utils/commonUtil'

import styles from './TagsList.module.scss'
import { TagsListItem } from './TagsListItem/TagsListItem'

export const TagsList = () => {
  const { buildRelative } = useLinkInternal()
  const { page } = usePage()
  const [search, setSearch] = useState('')
  const optionsTags = page?.optionsTags
  const cardIds = useMemo(
    () =>
      optionsTags
        ?.map(({ cardSlug }) => cardSlug)
        .filter(isNonEmptyString)
        .map((slug) => buildCardId({ slug })),
    [optionsTags],
  )
  const { cardMap, loading } = useCardMap({ cardIds })

  const options = useMemo(
    () =>
      optionsTags
        ?.map((o) => ({
          ...o,
          href: buildRelative({ section: 'tags', tagSlug: o.slug }),
          image: o.cardSlug ? cardMap[buildCardId({ slug: o.cardSlug })]?.imageArt : undefined,
        }))
        .filter(({ label }) => searchIncludes(search, label)) || [],
    [cardMap, optionsTags, search, buildRelative],
  )

  if (!optionsTags) return null

  return (
    <section className={styles.container}>
      <div className={styles.searchbox}>
        <InputSearchbox
          aria-label='Search tags'
          onChange={setSearch}
          onClear={() => setSearch('')}
          placeholder='Search tags...'
          size='lg'
          value={search}
        />
      </div>
      {options.length > 0 ? (
        <ul className={styles.tags}>
          {options.map(({ count, href, image, label, slug }) => (
            <TagsListItem count={count} href={href} image={image} key={slug} label={label} loading={loading} />
          ))}
        </ul>
      ) : (
        <NoResults size='lg' />
      )}
    </section>
  )
}
